
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/packages/fabfitfun",
      function () {
        return require("private-next-pages/packages/fabfitfun.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/packages/fabfitfun"])
      });
    }
  